import React, { useState } from "react";
import { useTier } from "../hooks/useTier";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "./ui/Button";
import { Crown, X } from "lucide-react";
import PaywallModal from "./PaywallModal";

const UpgradeBanner: React.FC = () => {
  const { isFree } = useTier();
  const { isGuest } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  if (!isFree || dismissed) {
    return null;
  }

  return (
    <>
      <div
        className="bg-warning-50 border-b border-warning-200 px-4 py-2 print:hidden"
        role="alert"
        data-testid="upgrade-banner"
      >
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-sm text-warning-800">
            <Crown
              className="h-4 w-4 flex-shrink-0 text-warning-600"
              aria-hidden="true"
            />
            <span>
              {isGuest
                ? "You're using a guest account."
                : "You're on the Free plan."}{" "}
              <strong>
                {isGuest
                  ? "Register to unlock Premium features."
                  : "Upgrade to Premium for unlimited meals and advanced features."}
              </strong>
            </span>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <Button
              size="sm"
              variant="warning"
              onClick={() => setModalOpen(true)}
              data-testid="upgrade-banner-cta"
            >
              Learn More
            </Button>
            <button
              type="button"
              onClick={() => setDismissed(true)}
              className="p-1 hover:bg-warning-100 rounded text-warning-700"
              aria-label="Dismiss banner"
              data-testid="dismiss-banner"
            >
              <X className="h-4 w-4" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
      <PaywallModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        isPremium={false}
      />
    </>
  );
};

export default UpgradeBanner;
